import { render, staticRenderFns } from "./c-meta-alarm-rule-field.vue?vue&type=template&id=23485c28&"
import script from "./c-meta-alarm-rule-field.vue?vue&type=script&lang=js&"
export * from "./c-meta-alarm-rule-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports